import React from 'react'
import styled from 'styled-components'
import { Button, IconPhone, IconChat, Typography } from '../Common'
import { FooterButtonsProps } from './footerButtons.props'

import { Config } from '../../config'

const icons: { [key: string]: any } = {
  phone: <IconPhone width="100%" height="100%" />,
  chat: <IconChat width="100%" height="100%" />,
}

export const FooterButtons = ({ buttons }: FooterButtonsProps) => {
  return (
    <Container>
      {buttons.map((btn) => (
        <ButtonWrapper key={`FooterButtons__${btn.url}_${btn.label}`}>
          <Button
            variant="primary"
            bordered
            borderRadius="small"
            fullWidth
            link={btn.url}
            style={{
              borderColor: Config.palette.grey,
              color: Config.palette.primary,
            }}
          >
            <IconWrapper>{icons[btn.icon]}</IconWrapper>
            <Typography variant="8">{btn.label}</Typography>
          </Button>
        </ButtonWrapper>
      ))}
    </Container>
  )
}

const ButtonWrapper = styled.div`
  text-align: center;
  width: 100%;

  & [data-btn] {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    display: none;
  }

  &:first-child {
    margin-right: 2rem;
  }
`

const Container = styled.div.attrs({
  className: 'mb-5 d-flex align-items-center justify-content-center',
})`
  max-width: 100%;
  padding: 0 2rem;
`

const IconWrapper = styled.span.attrs({
  className: 'mr-2',
})`
  height: 1.8rem;
  width: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
